import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  OnDestroy,
  HostListener,
} from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { MatAccordion, MatExpansionPanel } from "@angular/material/expansion";
import { Location } from "@angular/common";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { filter, takeUntil } from "rxjs/operators";
import { SidebarFreemiumDialogComponent } from './../../modules/shipyard/sidebar-freemium-dialog/sidebar-freemium-dialog.component';
import navRoutes, { allPermissions, navRoute, permissionCount } from "./nav-routes";
import { PermissionsEnum } from "src/app/core/PermissionsEnum";
import { Subject } from "rxjs";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { HeaderService } from "../header/header.service";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";

@Component({
  selector: "app-common-sidebar",
  templateUrl: "./common-sidebar.component.html",
  styleUrls: ["./common-sidebar.component.scss"],
})
export class CommonSidebarComponent implements OnInit,OnDestroy {
  @ViewChild("overlaySubMenu") overlaySubMenu: ElementRef;
  @ViewChild("subMenu") subMenu: ElementRef;
  @ViewChild("replenish") replenish: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter();
  @Input() accounts = [];
  isSidebarToggled: boolean;
  public userInfo: LoginModel;
  status:boolean = false;
  active:boolean = false;
  navRoutes: navRoute[];
  enteredButton: boolean= false;
  isMatMenuOpen:boolean = false;
  isMatMenu2Open:boolean = false;
  prevButtonTrigger;
  screenWidth:number
  purchasingQueueCount:number;
  public skuErrorCount: number;
  @HostListener('window:resize', ['$event'])
  getScreenWidth(event?) {
    this.screenWidth = window.innerWidth;
    if(this.screenWidth > 768){
      this.isSidebarToggled = false;
    }else{
      this.isSidebarToggled = true;
    } 
  }
 // public showLoginError: boolean;
  allPermissions: string[] = [...allPermissions];
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  openChildIndex:number;
  private destroy$ = new Subject<void>();
  queueCount:number=0;
  account;
  
  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private location:Location,
    private router: Router,
    private shipyardService:ShipyardService,
    private headerService:HeaderService,
    private purchasingService:PurchasingService,
    private gridActionServie:GridActionsService
  ) {
    this.headerService.accountsSelected
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      this.account = e[0];
      this.getQueueCount();
      this.getPurchasingQueueCount();
    })
    this.getQueueCount();
    this.shipyardService.updateQueueCount.pipe(takeUntil(this.destroy$)).subscribe((res:boolean)=>{
      if(res)
      this.getQueueCount();
    })

    this.purchasingService.updatePurchasingQueueCount.subscribe((res:boolean)=>{
      if(res){
        this.getPurchasingQueueCount();
        this.gridActionServie.getQueueList();
      }
    })
     
    this.authService.locationObs$.pipe(takeUntil(this.destroy$)).subscribe((e)=>{
      if(e && this.navRoutes){
        this.navRoutes.forEach((route) => (route.isActive = false));
        this.navRoutes.forEach((route)=>{
          if(route.children)
            route.children?.forEach((childRoute)=>{
            if(childRoute.url.length !== 0)
              if(e.includes(childRoute.url[0]) ||  childRoute.url[0].includes(e))
               route.isActive=true
              })
        })
      }
    })
  }

  ngOnInit() {
    this.authService.userInfo$
      .pipe(filter((e) => (e ? true : false)))
      .subscribe((res) => {
        this.userInfo = res;
        //this.getSignUpHour();
        this.navRoutes = navRoutes
          .filter((route) => {
            this.setPermissions(route)
            route.children = route.children?.filter((childRoute) => {
              this.setPermissions(childRoute)
             if(this.location.path().includes(childRoute.url[0]) ||  childRoute.url[0]?.includes(this.location.path()))
              route.isActive=true   
              if(childRoute?.children?.length !==0){           
              childRoute.children = childRoute.children?.filter((subchildRoute) => {
                this.setPermissions(subchildRoute)
                  if(this.location.path().includes(subchildRoute.url[0]) ||  subchildRoute.url[0]?.includes(this.location.path())){
                    childRoute.isActive=true
                    route.isActive=true;
                  }
                   return subchildRoute.permissions
                     ? this.userInfo[subchildRoute.permissions]
                     : true;
                 });
                }
                 return childRoute.permissions
                ? this.userInfo[childRoute.permissions]
                : true;
            });
            return route.permissions ? this.userInfo[route.permissions] : true;
          })
          .filter((route) => {
            if (route.excludeIfOnly) {
              const index = this.allPermissions.indexOf(route.excludeIfOnly);
              if (index > -1) {
                this.allPermissions.splice(index, 1);
              }

              const userPermissions = this.allPermissions.map(
                (item) => this.userInfo[item]
              );
              return userPermissions.some((item) => item) ? true : false;
            } else if(route.hasPermission){
              return permissionCount(this.userInfo) >= 1 ? true : false;
            } else if(route.isNonStandard){
                return this.userInfo.roleId !== 2;
            } else {
              return true;
            }
          });
      });
  }



  /*public getSignUpHour() {
    if (this.userInfo) {
      const d = this.userInfo.created;
      const ONE_HOUR = (60 * 60 * 1000) / 2;
      const myDate = new Date(d) as any;
      const now = new Date() as any;
      this.showLoginError = now - myDate < ONE_HOUR;
    }
  }*/

  public logout() {
    this.authService.logout();
  }

  public openBroadcastPopup(
    component: any,
    height: any,
    width: number,
    maxHeight: string,
    customClass: string
  ) {
    this.dialog.open(component, {
      width: `${width}px`,
      height: height === "auto" ? "auto" : `${height}px`,
      maxHeight,
      maxWidth: "92vw",
      panelClass: customClass !== undefined ? customClass : "",
      disableClose: true,
    });
  }

  toggleMenu() {
    this.isSidebarToggled = !this.isSidebarToggled;
    if (this.isSidebarToggled) {
      this.accordion.closeAll();
    }
    this.toggleSidebar.emit(this.isSidebarToggled);
  }

  buttonEnter(trigger) {
    setTimeout(() => {
      if (this.prevButtonTrigger && this.prevButtonTrigger != trigger) {
        this.prevButtonTrigger.closeMenu();
        this.prevButtonTrigger = trigger;
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        trigger.openMenu();
      } else if (!this.isMatMenuOpen) {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
        trigger.openMenu();
      } else {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
      }
    });
  }

  public buttonLeave(trigger, button) {
    setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        trigger.closeMenu();
      }
      if (!this.isMatMenuOpen) {
        trigger.closeMenu();
      } else {
        this.enteredButton = false;
      }
    }, 100);
  }

  openSidebar(navRoute) {
    if (this.isSidebarToggled && this.screenWidth > 768) {
      this.toggleMenu();
    }
    if(navRoute.enrollmentAction && !this.userInfo.isPlanYard){
      this.accordion.closeAll();
      this.router.navigate(navRoute.children[0].url);
    }
  }

  feedback() {
    window.open('https://feedback.nineyard.com', "_blank")
    // this.dialog
    //   .open(FeedbackDialogComponent, {
    //     width: "700px",
    //   })
    //   .afterClosed()
    //   .pipe(filter((e) => e))
    //   .subscribe((e) => {
    //     if (e !== "Cancel") {
    //       this.onboardingService
    //         .LeaveFeedback({ userId: this.userInfo.userId, message: e })
    //         .subscribe((e) => {
    //           this.snackbar.open("Your feedback was recorded.", "Dismiss", { duration: 3000 });
    //         });
    //     } else {
    //       this.snackbar.open("Your feedback was cancelled.", "Dismiss", { duration: 3000 });
    //     }
    //   });
  }

  closeOtherPanels(openPanel: MatExpansionPanel, navRoute,  subMenuPanel?: MatExpansionPanel,childRoute?, idx?) {
   let index;
    this.navRoutes.filter((route, i)=>{
      if(route.name==navRoute.name) index = i
      route.isActive = false
       if(route.children){
        route?.children.filter((el)=>{
          el.isActive = false
          if(idx !== undefined){
            if(el.name == childRoute.name) el.openChildIndex == idx ? el.openChildIndex = -1 : el.openChildIndex = idx;
            else el.openChildIndex = -1;            
          }  
        })
       }
    });
    this.navRoutes[index].isActive=true;
    this.panels.forEach(panel => {
      if (panel !== openPanel && panel !== subMenuPanel) {
        panel.close();
      }
    });
    if(navRoute.url == 'analytics'){
      if(childRoute?.children){
        this.active=!this.active;
      }
    }else{
      this.active = false
    }
  }

  closAllPanels() {
    this.navRoutes.filter((route) => (route.isActive = false)); 
    let index=this.navRoutes.findIndex((route)=>route.name=='Dashboard')
    this.navRoutes[index].isActive=true;
    this.panels.forEach(panel => {
            panel.close();
    });
  }

  redirectTodashboard(url){
    if(url.includes('/dashboard')){
      this.router.navigate(['/dashboard/product/netyard']);
      this.closAllPanels();  
    }
  }
  openFreemiumDialog(e: MouseEvent) {
    e.stopPropagation();
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialog.open(SidebarFreemiumDialogComponent, {
      width: "280px",
      position: {
        left: targetPosision.right - 24 + "px",
        top: targetPosision.top + 30 + "px",
      },
      backdropClass: ["cdk-overlay-transparent-backdrop"],
    }); 
  }

  Invite(){
    window.open('https://nineyard.firstpromoter.com/signup/20336', "_blank")
  }

  setPermissions(menu){
    const definedPermision=PermissionsEnum[menu.permissionName];
    const index=this.userInfo?.rolePermission?.findIndex((res: any)=> res == PermissionsEnum[menu.permissionName]);
    if((index == -1 && this.userInfo.role !== "Admin" && definedPermision) || (this.userInfo.isShipyard == 1 && this.userInfo.isPlanYard == null)) {
      menu.hasAccess = false;
    } else {
      menu.hasAccess = true;
    }
  }

  getQueueCount(){
    if(this.account)
      this.shipyardService.GetShipmentQueueCount(this.account).pipe(takeUntil(this.destroy$)).subscribe((res:number)=>{
        this.queueCount=res;
      })
    }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getPurchasingQueueCount(){
    this.purchasingService.GetPurchasingQueueCount().subscribe((res:number)=>{
      this.purchasingQueueCount=res;
      this.shipyardService.purchasingQueueCount=res;
    })
  }
}
